import throwData from "./throw.js"
export default {
    throwData,
    yaw_move:false,
    pitch_move:false,
    slider_boxFlag:false,

}